// /* Build Your Own Hamper — real Shopify Cart API integration
//    Uses Shopify's built-in AJAX Cart endpoints: /cart/add.js, /cart/change.js, /cart.js
//    No hardcoded product data — everything is rendered from Liquid and synced from the live cart.
// */
// // function showCelebration() {
// //   if (document.querySelector(".byoh-confetti")) return;

// //   const box = document.createElement("div");
// //   box.className = "byoh-confetti";

// //   const emojis = ["🎉", "🎊", "✨", "🥳", "🎁"];

// //   for (let i = 0; i < 25; i++) {
// //     const item = document.createElement("span");

// //     item.innerHTML =
// //       emojis[Math.floor(Math.random() * emojis.length)];

// //     item.style.left = Math.random() * 100 + "vw";
// //     item.style.top = "50vh";

// //     box.appendChild(item);
// //   }

// //   document.body.appendChild(box);

// //   setTimeout(() => {
// //     box.remove();
// //   }, 3000);
// // }
// function showCelebration() {
//   const old = document.querySelector(".byoh-confetti");

//   if (old) old.remove();

//   const box = document.createElement("div");
//   box.className = "byoh-confetti";

//   const emojis = ["🎉", "🎊", "✨", "🥳", "🎁"];

//   for (let i = 0; i < 30; i++) {
//     const item = document.createElement("span");

//     item.textContent =
//       emojis[Math.floor(Math.random() * emojis.length)];

//     item.style.left = Math.random() * 100 + "vw";

//     item.style.animationDelay =
//       Math.random() * 0.5 + "s";

//     box.appendChild(item);
//   }

//   document.body.appendChild(box);

//   setTimeout(() => {
//     box.remove();
//   }, 3000);
// }
// (function () {
//  var app = document.getElementById('byoh-app');
// if (!app) return;
// var isDedicatedPage = window.location.pathname.includes('build-your-own-hamper');
// if (!isDedicatedPage) {
//   app.classList.add('byoh-embedded');
// }

//   // Every line item added by this widget (box + goodies) carries this property
//   // so we can reliably tell "hamper items" apart from anything else already
//   // sitting in the customer's cart — and so the real /cart page can show
//   // which lines belong together.
//   var HAMPER_PROP_KEY = 'Part of';
//   var HAMPER_PROP_VALUE = 'Build Your Own Hamper';
//   // Hidden marker (underscore-prefixed properties are hidden from storefront
//   // display by convention, and this theme's cart template already skips
//   // them) placed ONLY on the box line — never on goodies — so the cart page
//   // can lock down exactly this one line and nothing else, including if the
//   // same box product is ever bought normally, outside this widget.
//   var HAMPER_NUMBER_KEY = 'Hamper';
//   var BOX_LOCK_KEY = '_byoh_box';
//   var BOX_LOCK_VALUE = 'true';
//   // Each "build session" gets its own ID, so multiple hampers can exist in
//   // the same cart without mixing into each other's progress count.
//   function getHamperId() {
//     var id = sessionStorage.getItem('byoh_hamper_id');
//     if (!id) {
//       id = 'h_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);
//       sessionStorage.setItem('byoh_hamper_id', id);
//     }
//     return id;
//   }
//   var CURRENT_HAMPER_ID = getHamperId();

//   function isHamperItem(item) {
//     return !!(item.properties &&
//       item.properties[HAMPER_PROP_KEY] === HAMPER_PROP_VALUE &&
//       item.properties['Hamper ID'] === CURRENT_HAMPER_ID);
//   }

//   // ---------- Offset the sticky hero below the theme's real header/menu ----------
//   var hero = document.getElementById('byoh-hero');

//   function findThemeHeaderHeight() {
//     var candidates = [
//       '#shopify-section-header-group',
//       '#shopify-section-header',
//       'header.ltn__header-area',
//       '.ltn__header-area',
//       '.ltn__sticky-menu',
//       'header[role="banner"]',
//       'header'
//     ];
//     for (var i = 0; i < candidates.length; i++) {
//       var el = document.querySelector(candidates[i]);
//       if (!el || el === hero || app.contains(el)) continue;
//       var style = window.getComputedStyle(el);
//       var rect = el.getBoundingClientRect();
//       if ((style.position === 'fixed' || style.position === 'sticky') && rect.top <= 1 && rect.height > 0) {
//         return rect.height;
//       }
//     }
//     for (var j = 0; j < candidates.length; j++) {
//       var fallbackEl = document.querySelector(candidates[j]);
//       if (!fallbackEl || fallbackEl === hero || app.contains(fallbackEl)) continue;
//       var fallbackRect = fallbackEl.getBoundingClientRect();
//       if (fallbackRect.top <= 1 && fallbackRect.height > 0) return fallbackRect.height;
//     }
//     return 0;
//   }

//   function positionHero() {
//     if (!hero) return;
//     var headerHeight = findThemeHeaderHeight();
//     document.documentElement.style.setProperty('--byoh-top', headerHeight + 'px');
//   }

//   window.addEventListener('load', positionHero);
//   window.addEventListener('resize', positionHero);
//   window.addEventListener('scroll', positionHero, { passive: true });
//   positionHero();
//   setTimeout(positionHero, 400); // catch late-loading theme headers/fonts

//   var MIN = parseInt(app.dataset.min, 10) || 5;
//   var MAX = parseInt(app.dataset.max, 10) || 7;
//   var BOX_VARIANT_ID = app.dataset.boxVariantId ? parseInt(app.dataset.boxVariantId, 10) : null;

//   var grid = document.getElementById('byoh-grid');
//   var search = document.getElementById('byoh-search');
//   var cartItemsEl = document.getElementById('byoh-cart-items');
//   var goodieCountEl = document.getElementById('byoh-goodie-count');
//   var subtotalEl = document.getElementById('byoh-subtotal');
//   var ribbonFill = document.getElementById('byoh-ribbon-fill');
//   var ribbonLabel = document.getElementById('byoh-ribbon-label');
//   var stickyMessage = document.getElementById('byoh-sticky-message');
//   var MIN_LABEL = MIN; // for message copy below

//   var allCards = Array.prototype.slice.call(grid.querySelectorAll('.byoh-card'));
//   var goodieVariantIds = allCards.map(function (c) { return parseInt(c.dataset.variantId, 10); });

//   function money(cents) {
//     return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
//   }

//   // ---------- Cart sync ----------
//   function fetchCart() {
//     return fetch('/cart.js').then(function (r) { return r.json(); });
//   }

//   // Only items WE tagged as part of the hamper — never anything else the
//   // customer already had in their cart, even if it happens to share a variant.
//   function hamperItems(cart) {
//     return cart.items.filter(isHamperItem);
//   }

//   function goodieLineItems(cart) {
//     return hamperItems(cart).filter(function (i) {
//       return goodieVariantIds.indexOf(i.variant_id) !== -1;
//     });
//   }

//   function goodieCount(cart) {
//     return goodieLineItems(cart).reduce(function (sum, i) { return sum + i.quantity; }, 0);
//   }

//   function findHamperLine(cart, variantId) {
//     return hamperItems(cart).filter(function (i) { return i.variant_id === variantId; })[0];
//   }

//  function ensureBoxInCart(cart) {
//     if (!BOX_VARIANT_ID) return Promise.resolve(cart);
//     var count = goodieCount(cart);
//     var boxLine = findHamperLine(cart, BOX_VARIANT_ID);

//     // No goodies selected — box should NOT be in the cart, remove it if present
//     if (count === 0) {
//       if (boxLine) {
//         return fetch('/cart/change.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: boxLine.key, quantity: 0 })
//         }).then(fetchCart);
//       }
//       return Promise.resolve(cart);
//     }

//     // Goodies selected but box missing — add it
//     if (!boxLine) {
//       return fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           items: [{
//             id: BOX_VARIANT_ID,
//             quantity: 1,
//             properties: makeBoxProps(cart)
//           }]
//         })
//       }).then(fetchCart);
//     }

//     return Promise.resolve(cart);
//   }

//   function getHamperNumber(cart) {

//   /*
//    * If this build already has a number saved,
//    * always reuse it.
//    */
//   var savedNumber =
//     sessionStorage.getItem('byoh_hamper_number');

//   if (savedNumber) {
//     return parseInt(savedNumber, 10);
//   }


//   /*
//    * Find all existing hamper IDs in the cart.
//    */
//   var ids = [];

//   cart.items.forEach(function (item) {

//     if (
//       item.properties &&
//       item.properties[HAMPER_PROP_KEY] === HAMPER_PROP_VALUE &&
//       item.properties['Hamper ID']
//     ) {

//       var id = item.properties['Hamper ID'];

//       if (ids.indexOf(id) === -1) {
//         ids.push(id);
//       }

//     }

//   });


//   /*
//    * This is a brand-new hamper,
//    * so its number is the next number.
//    */
//   var number = ids.length + 1;

//   sessionStorage.setItem(
//     'byoh_hamper_number',
//     String(number)
//   );

//   return number;
// }


// function makeProps(cart) {

//   var p = {};

//   p[HAMPER_PROP_KEY] =
//     HAMPER_PROP_VALUE;

//   p['Hamper ID'] =
//     CURRENT_HAMPER_ID;

//   p[HAMPER_NUMBER_KEY] =
//     'Hamper ' + getHamperNumber(cart);

//   return p;
// }


// function makeBoxProps(cart) {

//   var p = makeProps(cart);

//   p[BOX_LOCK_KEY] =
//     BOX_LOCK_VALUE;

//   return p;
// }
  

//   // ---------- Actions ----------
//   function addGoodie(variantId, btn) {
//   fetchCart().then(function (cart) {
//     if (goodieCount(cart) >= MAX) {
//       flash('Your hamper already has ' + MAX + ' goodies — the max per build. Remove one to add another.');
//       return;
//     }
//     btn.disabled = true;
//     btn.textContent = 'Adding…';
//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         items: [{
//           id: variantId,
//           quantity: 1,
//           properties: makeProps(cart)
//         }]
//       })
//     }).then(function (r) {
//       if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add item'); });
//       return r.json();
//     }).then(function () {
//       // Show a brief confirmation before morphing into the stepper
//       btn.textContent = '✓ Added!';
//       btn.classList.add('byoh-just-added');
//       setTimeout(refresh, 500);
//     }).catch(function (err) {
//       flash(err.message);
//       refresh();
//     });
//   });
// }

//   // Line items are changed by their unique `key`, not variant_id — a variant
//   // can appear in more than one line (e.g. once inside the hamper, once
//   // outside it with different properties), so variant_id alone isn't a safe
//   // target and was the reason the −/+ buttons weren't working reliably.
//   function changeQtyByKey(key, newQty) {
//     return fetch('/cart/change.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: key, quantity: newQty })
//     }).then(refresh);
//   }

//   function flash(msg) {
//     var note = document.createElement('div');
//     note.className = 'byoh-rule-note';
//     note.style.background = '#F8E5C8';
//     note.textContent = '⚠ ' + msg;
//     cartItemsEl.parentNode.insertBefore(note, cartItemsEl);
//     setTimeout(function () { note.remove(); }, 3200);
//   }

//   // ---------- Render ----------
//   function renderGrid(cart, filterText) {
//   var q = (filterText || '').trim().toLowerCase();
//   var count = goodieCount(cart);

//   allCards.forEach(function (card) {
//     var name = card.dataset.name.toLowerCase();
//     var matches = name.indexOf(q) !== -1;
//     card.style.display = matches ? '' : 'none';

//     var variantId = parseInt(card.dataset.variantId, 10);
//     var line = findHamperLine(cart, variantId);
//     var available = card.dataset.available === 'true';
//     var btn = card.querySelector('.byoh-add-btn');
//     var body = card.querySelector('.byoh-card-body');
//     var stepper = card.querySelector('.byoh-card-stepper');

//     if (line) {
//       // Item is in the hamper — show the stepper, hide the button
//       btn.style.display = 'none';
//       btn.classList.remove('byoh-just-added');

//       if (!stepper) {
//         stepper = document.createElement('div');
//         stepper.className = 'byoh-card-stepper';
//         stepper.innerHTML =
//           '<button type="button" class="byoh-card-qty-minus">−</button>' +
//           '<span class="byoh-card-qty-value"></span>' +
//           '<button type="button" class="byoh-card-qty-plus">+</button>';
//         body.appendChild(stepper);

//         stepper.querySelector('.byoh-card-qty-minus').addEventListener('click', function () {
//   fetchCart().then(function (freshCart) {
//     var current = findHamperLine(freshCart, variantId);
//     if (!current) return;
//     changeQtyByKey(current.key, Math.max(0, current.quantity - 1));
//   });
// });
//         stepper.querySelector('.byoh-card-qty-plus').addEventListener('click', function () {
//           fetchCart().then(function (freshCart) {
//             if (goodieCount(freshCart) >= MAX) {
//               flash('Your hamper already has ' + MAX + ' goodies — the max per build.');
//               return;
//             }
//             var current = findHamperLine(freshCart, variantId);
//             changeQtyByKey(current.key, current.quantity + 1);
//           });
//         });
//       }
//       stepper.style.display = 'flex';
//       stepper.querySelector('.byoh-card-qty-value').textContent = line.quantity;

//     } else {
//       // Not in the hamper — show the button, hide the stepper
//       btn.style.display = '';
//       if (stepper) stepper.style.display = 'none';

//       var atMax = count >= MAX;
//       btn.disabled = !available || atMax;
//       if (!available) btn.textContent = 'Out of stock';
//       else if (atMax) btn.textContent = 'Hamper full (' + MAX + ' max)';
//       else btn.textContent = 'Add to hamper';
//     }
//   });
// }

//   function renderCart(cart) {
//     var items = hamperItems(cart); // only OUR items, never the rest of the customer's cart

//     if (!items.length) {
//       cartItemsEl.innerHTML = '<p style="font-size:13px;opacity:.7;">Your hamper is empty.</p>';
//     } else {
//       cartItemsEl.innerHTML = items.map(function (item) {
//         var isBox = item.variant_id === BOX_VARIANT_ID;
//         return (
//           '<div class="byoh-cart-item">' +
//             '<img src="' + (item.image || '') + '" alt="">' +
//             '<div style="flex:1;min-width:0;">' +
//               '<div class="byoh-cart-item-name">' + item.product_title + (isBox ? ' <span style="opacity:.6;">(included)</span>' : '') + '</div>' +
//               '<div class="byoh-cart-item-price">' + money(item.price) + ' × ' + item.quantity + '</div>' +
//             '</div>' +
//             (isBox ? '' :
//               '<div style="display:flex;gap:6px;align-items:center;">' +
//                 '<button data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" class="byoh-qty-btn">−</button>' +
//                 '<span style="font-size:12.5px;font-weight:600;">' + item.quantity + '</span>' +
//                 '<button data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" class="byoh-qty-btn">+</button>' +
//               '</div>') +
//           '</div>'
//         );
//       }).join('');

//       cartItemsEl.querySelectorAll('.byoh-qty-btn').forEach(function (btn) {
//         btn.addEventListener('click', function () {
//           var qty = parseInt(btn.dataset.qty, 10);
//           var key = btn.dataset.key;
//           var current = items.filter(function (i) { return i.key === key; })[0];
//           var currentQty = current ? current.quantity : 0;

//           if (qty > currentQty && goodieCount(cart) >= MAX) {
//             flash('Your hamper already has ' + MAX + ' goodies — the max per build.');
//             return;
//           }
//           changeQtyByKey(key, Math.max(0, qty));
//         });
//       });
//     }

//    var count = goodieCount(cart);

// goodieCountEl.textContent = count + ' / ' + MAX;

// var hamperSubtotal = items.reduce(function (sum, i) {
//   return sum + i.line_price;
// }, 0);

// subtotalEl.textContent = money(hamperSubtotal);

// var pct = Math.min(count / MAX, 1) * 100;

// ribbonFill.style.width = pct + '%';

// ribbonLabel.textContent =
//   count + ' of ' + MAX + ' goodies added';

// if (stickyMessage) {
//   stickyMessage.classList.remove('byoh-unlocked');

//   if (count === 0) {
//     stickyMessage.textContent =
//       'Add ' + MIN_LABEL + ' goodies to unlock 10% off your hamper';
//   } else if (count < MIN_LABEL) {
//     var remaining = MIN_LABEL - count;

//     stickyMessage.textContent =
//       'Add ' + remaining + ' more goodies to unlock 10% off';
//   }else {
//   stickyMessage.textContent =
//     "10% off unlocked — applies automatically at checkout";

//   stickyMessage.classList.add("byoh-unlocked");

//   if (
//     count >= MIN_LABEL &&
//     !window.byohCelebrationShown
//   ) {
//     window.byohCelebrationShown = true;

//     showCelebration();
//   }
// }

// if (count < MIN_LABEL) {
//   window.byohCelebrationShown = false;
// }
// }
// }

//   function refresh() {
//     return fetchCart().then(function (cart) {
//       // Self-heal: if the box is missing but the customer has picked at
//       // least one goodie (or the box product exists at all), silently put
//       // it back. This runs on every refresh, not just page load, so the
//       // box can't be permanently removed while the customer is on this page.
//       return ensureBoxInCart(cart);
//     }).then(function (cart) {
//       renderCart(cart);
//       renderGrid(cart, search.value);
//       return cart;
//     });
//   }

//   // ---------- Events ----------
//   grid.addEventListener('click', function (e) {
//     var btn = e.target.closest('.byoh-add-btn');
//     if (!btn || btn.disabled) return;
//     addGoodie(parseInt(btn.dataset.variantId, 10), btn);
//   });

//   search.addEventListener('input', function () {
//     fetchCart().then(function (cart) { renderGrid(cart, search.value); });
//   });

//   // Catch removals made through the theme's own cart drawer/icon (not this
//   // widget), which this script has no direct visibility into otherwise.
//   window.addEventListener('focus', refresh);
//   document.addEventListener('visibilitychange', function () {
//     if (document.visibilityState === 'visible') refresh();
//   });
//   document.addEventListener('cart:updated', refresh);   // common theme event name
//   document.addEventListener('cart:refresh', refresh);    // common theme event name
//   setInterval(refresh, 15000); // safety-net poll every 15s while this page is open

//   // ---------- Init: ensure box in cart, then render ----------
//   fetchCart().then(ensureBoxInCart).then(function (cart) {
//     renderCart(cart);
//     renderGrid(cart, '');
//   });
//   var viewHamperBtn = document.querySelector('.byoh-sticky-cta');
// if (viewHamperBtn) {
//   viewHamperBtn.addEventListener('click', function (e) {
//     e.preventDefault();
//     var target = document.getElementById('byoh-cart-panel');
//     if (!target) return;
//     var offset = hero ? hero.offsetHeight : 0;
//     var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 12;
//     window.scrollTo({ top: top, behavior: 'smooth' });
//   });
// }
// })();
// /* =========================================================
//    ADD NEW HAMPER
//    Starts a fresh hamper session without clearing the cart.
//    ========================================================= */

// (function () {

//   var newHamperBtn =
//     document.getElementById('byoh-new-hamper-btn');

//   if (!newHamperBtn) return;

//   newHamperBtn.addEventListener('click', function () {

//     // Forget the current hamper session only.
//     // Shopify cart items are NOT deleted.

//     sessionStorage.removeItem('byoh_hamper_id');
//     sessionStorage.removeItem('byoh_hamper_number');

//   });

// })();




/* Build Your Own Hamper — real Shopify Cart API integration
   Uses Shopify's built-in AJAX Cart endpoints: /cart/add.js, /cart/change.js, /cart.js
   No hardcoded product data — everything is rendered from Liquid and synced from the live cart.
*/
// function showCelebration() {
//   if (document.querySelector(".byoh-confetti")) return;

//   const box = document.createElement("div");
//   box.className = "byoh-confetti";

//   const emojis = ["🎉", "🎊", "✨", "🥳", "🎁"];

//   for (let i = 0; i < 25; i++) {
//     const item = document.createElement("span");

//     item.innerHTML =
//       emojis[Math.floor(Math.random() * emojis.length)];

//     item.style.left = Math.random() * 100 + "vw";
//     item.style.top = "50vh";

//     box.appendChild(item);
//   }

//   document.body.appendChild(box);

//   setTimeout(() => {
//     box.remove();
//   }, 3000);
// }
function showCelebration() {
  const old = document.querySelector(".byoh-confetti");

  if (old) old.remove();

  const box = document.createElement("div");
  box.className = "byoh-confetti";

  const emojis = ["🎉", "🎊", "✨", "🥳", "🎁"];

  for (let i = 0; i < 30; i++) {
    const item = document.createElement("span");

    item.textContent =
      emojis[Math.floor(Math.random() * emojis.length)];

    item.style.left = Math.random() * 100 + "vw";

    item.style.animationDelay =
      Math.random() * 0.5 + "s";

    box.appendChild(item);
  }

  document.body.appendChild(box);

  setTimeout(() => {
    box.remove();
  }, 3000);
}
(function () {
 var app = document.getElementById('byoh-app');
if (!app) return;
var isDedicatedPage = window.location.pathname.includes('build-your-own-hamper');
if (!isDedicatedPage) {
  app.classList.add('byoh-embedded');
}

  // Every line item added by this widget (box + goodies) carries this property
  // so we can reliably tell "hamper items" apart from anything else already
  // sitting in the customer's cart — and so the real /cart page can show
  // which lines belong together.
  var HAMPER_PROP_KEY = 'Part of';
  var HAMPER_PROP_VALUE = 'Build Your Own Hamper';
  // Hidden marker (underscore-prefixed properties are hidden from storefront
  // display by convention, and this theme's cart template already skips
  // them) placed ONLY on the box line — never on goodies — so the cart page
  // can lock down exactly this one line and nothing else, including if the
  // same box product is ever bought normally, outside this widget.
  var HAMPER_NUMBER_KEY = 'Hamper';
  var BOX_LOCK_KEY = '_byoh_box';
  var BOX_LOCK_VALUE = 'true';
  // Each "build session" gets its own ID, so multiple hampers can exist in
  // the same cart without mixing into each other's progress count.
  function getHamperId() {
    var id = sessionStorage.getItem('byoh_hamper_id');
    if (!id) {
      id = 'h_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);
      sessionStorage.setItem('byoh_hamper_id', id);
    }
    return id;
  }
  var CURRENT_HAMPER_ID = getHamperId();

  function isHamperItem(item) {
    return !!(item.properties &&
      item.properties[HAMPER_PROP_KEY] === HAMPER_PROP_VALUE &&
      item.properties['Hamper ID'] === CURRENT_HAMPER_ID);
  }

  // ---------- Offset the sticky hero below the theme's real header/menu ----------
  var hero = document.getElementById('byoh-hero');

  function findThemeHeaderHeight() {
    var candidates = [
      '#shopify-section-header-group',
      '#shopify-section-header',
      'header.ltn__header-area',
      '.ltn__header-area',
      '.ltn__sticky-menu',
      'header[role="banner"]',
      'header'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (!el || el === hero || app.contains(el)) continue;
      var style = window.getComputedStyle(el);
      var rect = el.getBoundingClientRect();
      if ((style.position === 'fixed' || style.position === 'sticky') && rect.top <= 1 && rect.height > 0) {
        return rect.height;
      }
    }
    for (var j = 0; j < candidates.length; j++) {
      var fallbackEl = document.querySelector(candidates[j]);
      if (!fallbackEl || fallbackEl === hero || app.contains(fallbackEl)) continue;
      var fallbackRect = fallbackEl.getBoundingClientRect();
      if (fallbackRect.top <= 1 && fallbackRect.height > 0) return fallbackRect.height;
    }
    return 0;
  }

  function positionHero() {
    if (!hero) return;
    var headerHeight = findThemeHeaderHeight();
    document.documentElement.style.setProperty('--byoh-top', headerHeight + 'px');
  }

  window.addEventListener('load', positionHero);
  window.addEventListener('resize', positionHero);
  positionHero();
  setTimeout(positionHero, 400); // catch late-loading theme headers/fonts

  var MIN = parseInt(app.dataset.min, 10) || 5;
  var MAX = parseInt(app.dataset.max, 10) || 7;
  var BOX_VARIANT_ID = app.dataset.boxVariantId ? parseInt(app.dataset.boxVariantId, 10) : null;

  var grid = document.getElementById('byoh-grid');
  var search = document.getElementById('byoh-search');
  var cartItemsEl = document.getElementById('byoh-cart-items');
  var goodieCountEl = document.getElementById('byoh-goodie-count');
  var subtotalEl = document.getElementById('byoh-subtotal');
  var ribbonFill = document.getElementById('byoh-ribbon-fill');
  var ribbonLabel = document.getElementById('byoh-ribbon-label');
  var stickyMessage = document.getElementById('byoh-sticky-message');
  var MIN_LABEL = MIN; // for message copy below

  var allCards = Array.prototype.slice.call(grid.querySelectorAll('.byoh-card'));
  var goodieVariantIds = allCards.map(function (c) { return parseInt(c.dataset.variantId, 10); });

  function money(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  // ---------- Cart sync ----------
  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  // Only items WE tagged as part of the hamper — never anything else the
  // customer already had in their cart, even if it happens to share a variant.
  function hamperItems(cart) {
    return cart.items.filter(isHamperItem);
  }

  function goodieLineItems(cart) {
    return hamperItems(cart).filter(function (i) {
      return goodieVariantIds.indexOf(i.variant_id) !== -1;
    });
  }

  function goodieCount(cart) {
    return goodieLineItems(cart).reduce(function (sum, i) { return sum + i.quantity; }, 0);
  }

  function findHamperLine(cart, variantId) {
    return hamperItems(cart).filter(function (i) { return i.variant_id === variantId; })[0];
  }

 function ensureBoxInCart(cart) {
    if (!BOX_VARIANT_ID) return Promise.resolve(cart);
    var count = goodieCount(cart);
    var boxLine = findHamperLine(cart, BOX_VARIANT_ID);

    // No goodies selected — box should NOT be in the cart, remove it if present
    if (count === 0) {
      if (boxLine) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: boxLine.key, quantity: 0 })
        }).then(fetchCart);
      }
      return Promise.resolve(cart);
    }

    // Goodies selected but box missing — add it
    if (!boxLine) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: BOX_VARIANT_ID,
            quantity: 1,
            properties: makeBoxProps(cart)
          }]
        })
      }).then(fetchCart);
    }

    return Promise.resolve(cart);
  }

  function getHamperNumber(cart) {

  /*
   * If this build already has a number saved,
   * always reuse it.
   */
  var savedNumber =
    sessionStorage.getItem('byoh_hamper_number');

  if (savedNumber) {
    return parseInt(savedNumber, 10);
  }


  /*
   * Find all existing hamper IDs in the cart.
   */
  var ids = [];

  cart.items.forEach(function (item) {

    if (
      item.properties &&
      item.properties[HAMPER_PROP_KEY] === HAMPER_PROP_VALUE &&
      item.properties['Hamper ID']
    ) {

      var id = item.properties['Hamper ID'];

      if (ids.indexOf(id) === -1) {
        ids.push(id);
      }

    }

  });


  /*
   * This is a brand-new hamper,
   * so its number is the next number.
   */
  var number = ids.length + 1;

  sessionStorage.setItem(
    'byoh_hamper_number',
    String(number)
  );

  return number;
}


function makeProps(cart) {

  var p = {};

  p[HAMPER_PROP_KEY] =
    HAMPER_PROP_VALUE;

  p['Hamper ID'] =
    CURRENT_HAMPER_ID;

  p[HAMPER_NUMBER_KEY] =
    'Hamper ' + getHamperNumber(cart);

  return p;
}


function makeBoxProps(cart) {

  var p = makeProps(cart);

  p[BOX_LOCK_KEY] =
    BOX_LOCK_VALUE;

  return p;
}
  

  // ---------- Actions ----------
  function addGoodie(variantId, btn) {
    // Give instant visual feedback while Shopify processes the add request.
    // The live cart remains the source of truth and refresh() reconciles it.
    var displayedCount = parseInt(goodieCountEl.textContent, 10);
    if (isNaN(displayedCount)) displayedCount = 0;
    if (displayedCount < MAX) renderProgress(displayedCount + 1, true);

  fetchCart().then(function (cart) {
    if (goodieCount(cart) >= MAX) {
      flash('Your hamper already has ' + MAX + ' goodies — the max per build. Remove one to add another.');
      return;
    }
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: makeProps(cart)
        }]
      })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add item'); });
      return r.json();
    }).then(function () {
      // Show a brief confirmation before morphing into the stepper
      btn.textContent = '✓ Added!';
      btn.classList.add('byoh-just-added');
      setTimeout(refresh, 500);
    }).catch(function (err) {
      flash(err.message);
      refresh();
    });
  });
}

  // Line items are changed by their unique `key`, not variant_id — a variant
  // can appear in more than one line (e.g. once inside the hamper, once
  // outside it with different properties), so variant_id alone isn't a safe
  // target and was the reason the −/+ buttons weren't working reliably.
  function changeQtyByKey(key, newQty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    }).then(refresh);
  }

  function flash(msg) {
    var note = document.createElement('div');
    note.className = 'byoh-rule-note';
    note.style.background = '#F8E5C8';
    note.textContent = '⚠ ' + msg;
    cartItemsEl.parentNode.insertBefore(note, cartItemsEl);
    setTimeout(function () { note.remove(); }, 3200);
  }

  // ---------- Render ----------
  function renderGrid(cart, filterText) {
  var q = (filterText || '').trim().toLowerCase();
  var count = goodieCount(cart);

  allCards.forEach(function (card) {
    var name = card.dataset.name.toLowerCase();
    var matches = name.indexOf(q) !== -1;
    card.style.display = matches ? '' : 'none';

    var variantId = parseInt(card.dataset.variantId, 10);
    var line = findHamperLine(cart, variantId);
    var available = card.dataset.available === 'true';
    var btn = card.querySelector('.byoh-add-btn');
    var body = card.querySelector('.byoh-card-body');
    var stepper = card.querySelector('.byoh-card-stepper');

    if (line) {
      // Item is in the hamper — show the stepper, hide the button
      btn.style.display = 'none';
      btn.classList.remove('byoh-just-added');

      if (!stepper) {
        stepper = document.createElement('div');
        stepper.className = 'byoh-card-stepper';
        stepper.innerHTML =
          '<button type="button" class="byoh-card-qty-minus">−</button>' +
          '<span class="byoh-card-qty-value"></span>' +
          '<button type="button" class="byoh-card-qty-plus">+</button>';
        body.appendChild(stepper);

        stepper.querySelector('.byoh-card-qty-minus').addEventListener('click', function () {
  fetchCart().then(function (freshCart) {
    var current = findHamperLine(freshCart, variantId);
    if (!current) return;
    changeQtyByKey(current.key, Math.max(0, current.quantity - 1));
  });
});
        stepper.querySelector('.byoh-card-qty-plus').addEventListener('click', function () {
          fetchCart().then(function (freshCart) {
            if (goodieCount(freshCart) >= MAX) {
              flash('Your hamper already has ' + MAX + ' goodies — the max per build.');
              return;
            }
            var current = findHamperLine(freshCart, variantId);
            changeQtyByKey(current.key, current.quantity + 1);
          });
        });
      }
      stepper.style.display = 'flex';
      stepper.querySelector('.byoh-card-qty-value').textContent = line.quantity;

    } else {
      // Not in the hamper — show the button, hide the stepper
      btn.style.display = '';
      if (stepper) stepper.style.display = 'none';

      var atMax = count >= MAX;
      btn.disabled = !available || atMax;
      if (!available) btn.textContent = 'Out of stock';
      else if (atMax) btn.textContent = 'Hamper full (' + MAX + ' max)';
      else btn.textContent = 'Add to hamper';
    }
  });
}

  function renderProgress(count, animate) {
    count = Math.max(0, Math.min(parseInt(count, 10) || 0, MAX));

    goodieCountEl.textContent = count + ' / ' + MAX;
    ribbonFill.style.width = (Math.min(count / MAX, 1) * 100) + '%';
    if (animate && ribbonFill) {
      ribbonFill.classList.remove('byoh-progress-pulse');
      void ribbonFill.offsetWidth;
      ribbonFill.classList.add('byoh-progress-pulse');
    }
    if (animate && goodieCountEl) {
      goodieCountEl.classList.remove('byoh-count-pulse');
      void goodieCountEl.offsetWidth;
      goodieCountEl.classList.add('byoh-count-pulse');
    }
    ribbonLabel.textContent = count + ' of ' + MAX + ' goodies added';

    if (stickyMessage) {
      stickyMessage.classList.remove('byoh-unlocked');
      if (count === 0) {
        stickyMessage.textContent = 'Add ' + MIN_LABEL + ' goodies to unlock 10% off your hamper';
      } else if (count < MIN_LABEL) {
        var remaining = MIN_LABEL - count;
        stickyMessage.textContent = 'Add ' + remaining + ' more goodies to unlock 10% off';
      } else {
        stickyMessage.textContent = '10% off unlocked — applies automatically at checkout';
        stickyMessage.classList.add('byoh-unlocked');
      }
    }
  }

  function renderCart(cart) {
    var items = hamperItems(cart); // only OUR items, never the rest of the customer's cart

    if (!items.length) {
      cartItemsEl.innerHTML = '<p style="font-size:13px;opacity:.7;">Your hamper is empty.</p>';
    } else {
      cartItemsEl.innerHTML = items.map(function (item) {
        var isBox = item.variant_id === BOX_VARIANT_ID;
        return (
          '<div class="byoh-cart-item">' +
            '<img src="' + (item.image || '') + '" alt="">' +
            '<div style="flex:1;min-width:0;">' +
              '<div class="byoh-cart-item-name">' + item.product_title + (isBox ? ' <span style="opacity:.6;">(included)</span>' : '') + '</div>' +
              '<div class="byoh-cart-item-price">' + money(item.price) + ' × ' + item.quantity + '</div>' +
            '</div>' +
            (isBox ? '' :
              '<div style="display:flex;gap:6px;align-items:center;">' +
                '<button data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" class="byoh-qty-btn">−</button>' +
                '<span style="font-size:12.5px;font-weight:600;">' + item.quantity + '</span>' +
                '<button data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" class="byoh-qty-btn">+</button>' +
              '</div>') +
          '</div>'
        );
      }).join('');

      cartItemsEl.querySelectorAll('.byoh-qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var qty = parseInt(btn.dataset.qty, 10);
          var key = btn.dataset.key;
          var current = items.filter(function (i) { return i.key === key; })[0];
          var currentQty = current ? current.quantity : 0;

          if (qty > currentQty && goodieCount(cart) >= MAX) {
            flash('Your hamper already has ' + MAX + ' goodies — the max per build.');
            return;
          }
          changeQtyByKey(key, Math.max(0, qty));
        });
      });
    }

   var count = goodieCount(cart);
   renderProgress(count);

   var hamperSubtotal = items.reduce(function (sum, i) {
     return sum + i.line_price;
   }, 0);

   subtotalEl.textContent = money(hamperSubtotal);

   // Keep the existing celebration behavior unchanged.
   if (count >= MIN_LABEL && !window.byohCelebrationShown) {
     window.byohCelebrationShown = true;
     showCelebration();
   }

   if (count < MIN_LABEL) {
     window.byohCelebrationShown = false;
   }

}

  function refresh() {
    return fetchCart().then(function (cart) {
      // Self-heal: if the box is missing but the customer has picked at
      // least one goodie (or the box product exists at all), silently put
      // it back. This runs on every refresh, not just page load, so the
      // box can't be permanently removed while the customer is on this page.
      return ensureBoxInCart(cart);
    }).then(function (cart) {
      renderCart(cart);
      renderGrid(cart, search.value);
      return cart;
    });
  }

  // ---------- Events ----------
  grid.addEventListener('click', function (e) {
    var btn = e.target.closest('.byoh-add-btn');
    if (!btn || btn.disabled) return;
    addGoodie(parseInt(btn.dataset.variantId, 10), btn);
  });

  search.addEventListener('input', function () {
    fetchCart().then(function (cart) { renderGrid(cart, search.value); });
  });

  // Catch removals made through the theme's own cart drawer/icon (not this
  // widget), which this script has no direct visibility into otherwise.
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh();
  });
  document.addEventListener('cart:updated', refresh);   // common theme event name
  document.addEventListener('cart:refresh', refresh);    // common theme event name
  setInterval(refresh, 15000); // safety-net poll every 15s while this page is open

  // ---------- Init: ensure box in cart, then render ----------
  fetchCart().then(ensureBoxInCart).then(function (cart) {
    renderCart(cart);
    renderGrid(cart, '');
  });
  var viewHamperBtn = document.querySelector('.byoh-sticky-cta');
if (viewHamperBtn) {
  viewHamperBtn.addEventListener('click', function (e) {
    e.preventDefault();
    var target = document.getElementById('byoh-cart-panel');
    if (!target) return;
    var offset = hero ? hero.offsetHeight : 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 12;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
}
})();
/* =========================================================
   ADD NEW HAMPER
   Starts a fresh hamper session without clearing the cart.
   ========================================================= */

(function () {

  var newHamperBtn =
    document.getElementById('byoh-new-hamper-btn');

  if (!newHamperBtn) return;

  newHamperBtn.addEventListener('click', function () {

    // Forget the current hamper session only.
    // Shopify cart items are NOT deleted.

    sessionStorage.removeItem('byoh_hamper_id');
    sessionStorage.removeItem('byoh_hamper_number');

  });

})();

/* BYOH layout note:
   The visual overlap fix is intentionally handled by the scoped CSS.
   No cart/progress/add-to-hamper functionality is changed here. */
